import { COLORS, interpolateColor, getCellColor } from './cellColors';

/** Driver history stats shown as colored badges (Predictions rows and Simulator rows). */
export type StatKey = 'avgStart' | 'avgFinish' | 'avgRating' | 'top15Pct' | 'avgRunningPos';

export const statLabels: Record<StatKey, string> = {
  avgStart: 'Start',
  avgFinish: 'Finish',
  avgRating: 'Rating',
  top15Pct: 'T15',
  avgRunningPos: 'Avg',
};

/** Badge background for a stat: green = good, yellow = middling, red = poor. */
export const getBadgeColor = (value: number, stat: string) => {
  switch (stat) {
    case 'avgStart': // Lower is better (1-40)
    case 'avgFinish':
    case 'avgRunningPos':
      return getCellColor(value, 'position');
    case 'avgRating': // Higher is better (40-120 typical driver rating)
      {
        const min = 40, max = 120;
        const factor = Math.max(0, Math.min(1, (value - min) / (max - min)));
        // 40 (red) to 80 (yellow) to 120 (green)
        if (factor <= 0.5) {
          return interpolateColor(COLORS.min, COLORS.mid, factor * 2);
        } else {
          return interpolateColor(COLORS.mid, COLORS.max, (factor - 0.5) * 2);
        }
      }
    case 'top15Pct': // Higher is better (0-100%)
      {
        const factor = Math.max(0, Math.min(1, value / 100));
        if (factor <= 0.5) {
          return interpolateColor(COLORS.min, COLORS.mid, factor * 2);
        } else {
          return interpolateColor(COLORS.mid, COLORS.max, (factor - 0.5) * 2);
        }
      }
    default:
      return COLORS.mid;
  }
};

/** How a stat is printed inside its badge. */
export const formatStat = (key: StatKey, value: number): string =>
  key === 'top15Pct' ? `${Math.round(value)}%` : key === 'avgRating' ? String(Math.round(value)) : value.toFixed(1);
